import API from "../../api/authservice";
import router from "../../router/index";
import _ from "lodash";
import { Object } from "core-js";

const state = {
  token: window.sessionStorage.getItem("auth_token") || "",
  user: {},
  userAccessDetails: {},
  errors: [],
  userBuckets: [],
  notifications: [],
  iframeData: [],
};
const getters = {
  isLoggedIn: (state) => !!state.token,
  userDetails: (state) => state.user,
  getToken: (state) => state.token,
  userAccessDetails: (state) => state.userAccessDetails,
  userBuckets: (state) => state.userBuckets,
  notifications: (state) => state.notifications,
  iframeData: (state) => state.iframeData,
  getErrors: (state) => state.errors,
};
const actions = {
  async logout({ commit, dispatch }) {
    commit("SET_TOKEN", null);
    localStorage.clear();
    sessionStorage.clear();
    window.sessionStorage.removeItem("auth_token");
  },
  async login({ dispatch, commit }, user) {
  dispatch("showLoader");
  let notification = {};
    try {
      const { data } = await API.login(user);
      let auth_token = data.access;
      window.sessionStorage.setItem("auth_token", auth_token);
      commit("SET_TOKEN", auth_token);
      let getUserData = await dispatch("getUser");
      getUserData = JSON.stringify(getUserData);
      window.sessionStorage.setItem("getUserData", getUserData);
      // console.log("getUserData+>>??", getUserData);
      await dispatch("getUserAccessDetails");
      router.push("/dashboard");
    } catch (error) {
      if (error && error.response && error.response.data) {
        // console.error(error);
        commit("SET_ERROR", error);
        notification = {
          message: error.response.data.message,
          type: "DANGER",
        };
        commit("PUSH_NOTIFICATION", notification);
        setTimeout(() => {
          commit("PUSH_NOTIFICATION", {});
        }, 7000);
        commit("SET_ERROR", error.response.data.detail);
      }
    }
    dispatch("hideLoader");
  },
  async getUser({ commit }) {
    const { data } = await API.getUserProfile();
    commit("SET_USER", data);
    return data;
  },
  async getUserAccessDetails({ commit }) {
    let notification = {};
    try {
      let getUserData = window.sessionStorage.getItem("getUserData");
      getUserData = JSON.parse(getUserData);
      // console.log("getUserData==___>>>", getUserData);
      const { data } = await API.userAccessData(getUserData);
      let userData = data.message.data;
      commit("SET_USER_ACCESS_DETAILS", userData);
      commit("SET_USER_BUCKETS", userData);
      let waterfallData = userData.filter((i) => i.objectname == "Waterfall");
      let valuationData = userData.filter((i) => i.objectname == "Valuation");
      let iMost = userData.filter((i) => i.objectname == "Sensitivity Table");
      let stock_screens = userData.filter(
        (i) => i.objectname == "Stock Screens"
      );
      let sector = userData.filter(
        (i) => i.objectname == "Sector/Industry Insights"
      );
      let macro = userData.filter(
        (i) => i.objectname == "Macro Economic Indicators"
      );
      let coverage = userData.filter(
        (i) => i.objectname == "Coverage Universe"
      );
      if (waterfallData.length > 0) commit("SET_WATERFALL", waterfallData[0]);
      if (valuationData.length > 0) commit("SET_VALUATION", valuationData[0]);
      if (iMost.length > 0) commit("SET_IMOST", iMost[0]);
      if (stock_screens.length > 0)
        commit("SET_STOCK_SCREENS", stock_screens[0]);
      if (sector.length > 0) commit("SET_SECTOR", sector[0]);
      if (coverage.length > 0) commit("SET_COVERAGE", coverage[0]);
      if (macro.length > 0) {
        commit("SET_MACRO", macro[0]);

        let recessionrisk = macro[0].child.filter(
          (i) => i.objectname.trim() == "Recession Risk Still Limited Near-term"
        );
        let leadingIndicator = macro[0].child.filter(
          (i) => i.objectname.trim() == "Leading Indicator"
        );
        let usindustrialproduction = macro[0].child.filter(
          (i) => i.objectname.trim() == "US Industrial Production"
        );
        let gdp = macro[0].child.filter((i) => i.objectname.trim() == "GDP");
        let inventory = macro[0].child.filter(
          (i) => i.objectname.toLowerCase().trim() == "inventory"
        );
        let consumerspending = macro[0].child.filter(
          (i) => i.objectname.toLowerCase().trim() == "consumer spending"
        );
        let usconstruction = macro[0].child.filter(
          (i) => i.objectname.toLowerCase().trim() == "us construction"
        );
        let inflationhardertopace = macro[0].child.filter(
          (i) => i.objectname.trim() == "Inflation Harder to Pace"
        );
        let inflation = macro[0].child.filter(
          (i) => i.objectname.toLowerCase().trim() == "inflation"
        );
        let capitalspending = macro[0].child.filter(
          (i) => i.objectname.toLowerCase().trim() == "capital spending"
        );
        let corn = macro[0].child.filter(
          (i) => i.objectname.toLowerCase().trim() == "corn"
        );
        let netdebteditda = macro[0].child.filter(
          (i) => i.objectname.toLowerCase().trim() == "net/debt/editda"
        );
        let regionaltrends = macro[0].child.filter(
          (i) => i.objectname.toLowerCase().trim() == "regional trends"
        );
        let retailSales = macro[0].child.filter(
          (i) => i.objectname.toLowerCase().trim() == "retail sales"
        );
        if (recessionrisk.length > 0)
          commit("SET_RECESSIONRISK", recessionrisk[0]);
        if (usindustrialproduction.length > 0)
          commit("SET_USINDUSTRIALPRODUCTION", usindustrialproduction[0]);
        if (leadingIndicator.length > 0)
          commit("SET_LEADINGINDICATOR", leadingIndicator[0]);
        if (gdp.length > 0) commit("SET_GDP", gdp[0]);
        if (inventory.length > 0) commit("SET_INVENTORY", inventory[0]);
        if (consumerspending.length > 0)
          commit("SET_CONSUMERSPENDING", consumerspending[0]);
        if (usconstruction.length > 0)
          commit("SET_USCONSTRUCTION", usconstruction[0]);
        if (inflationhardertopace.length > 0)
          commit("SET_INFLATIONHARDERTOPACE", inflationhardertopace[0]);
        if (inflation.length > 0) commit("SET_INFLATION", inflation[0]);
        if (capitalspending.length > 0)
          commit("SET_CAPITALSPENDING", capitalspending[0]);
        if (corn.length > 0) commit("SET_CORN", corn[0]);
        if (netdebteditda.length > 0)
          commit("SET_NETDEBTEDITDA", netdebteditda[0]);
        if (regionaltrends.length > 0)
          commit("SET_REGIONALTRENDS", regionaltrends[0]);
        if (retailSales.length > 0)
          commit("SET_RETAIL_SALES", retailSales[0]);
      }
    } catch (error) {
      // console.log("Login ERROR.....", error);
      if (error && error.response && error.response.data) {
        // console.error(error);
        commit("SET_ERROR", error);
        notification = {
          message: error.response.data.message,
          type: "DANGER",
        };
        commit("PUSH_NOTIFICATION", notification);
        setTimeout(() => {
          commit("PUSH_NOTIFICATION", {});
        }, 7000);
        commit("SET_ERROR", error.response.data.detail);
      }
    }
  },
  //New User Registration
  async register({ commit, dispatch }, data) {
  dispatch("showLoader");
  let notification = {};
    try {
      let response = await API.register(data);
      let user_data = response.data;
      // console.log("register", response);
      let notification = {
        message: 'User registered successfully and pending for admin approval',
        type: "SUCCESS",
      };
      commit("PUSH_NOTIFICATION", notification);
      setTimeout(() => {
        commit("PUSH_NOTIFICATION", {});
      }, 7000);
      dispatch("hideLoader");
      return user_data;
    } catch (error) {
      console.error("erros", error);
      commit("SET_ERROR", error);
      let data = error.response.data;
      let notificationMessage;
      for (let key in data) {
        if (key != "status") {
          if (typeof data[key] != "string") {
            notificationMessage = data[key][0];
          } else {
            notificationMessage = data[key];
          }
        }
      }
      let notification = {
        message: notificationMessage,
        type: "DANGER",
      };
      commit("PUSH_NOTIFICATION", notification);
      setTimeout(() => {
        commit("PUSH_NOTIFICATION", {});
      }, 7000);
      dispatch("hideLoader");
      return error.response.data;
    }
  },
  async forgotPassword({ commit, dispatch }, data) {
    let notification = {};
  // console.log("data++", data);
  dispatch("showLoader");
    try {
      let response = await API.changepassword(data);
      let user_data = response.data;
      notification = {
        message: user_data.message,
        type: "SUCCESS",
      };
      commit("PUSH_NOTIFICATION", notification);
      setTimeout(() => {
        commit("PUSH_NOTIFICATION", {});
      }, 7000);
      dispatch("hideLoader");
      return user_data;
    } catch (error) {
      if (error && error.response && error.response.data) {
        // console.error(error);
        commit("SET_ERROR", error);
        notification = {
          message: error.response.data.message,
          type: "DANGER",
        };
        commit("PUSH_NOTIFICATION", notification);
        setTimeout(() => {
          commit("PUSH_NOTIFICATION", {});
        }, 7000);
        commit("SET_ERROR", error.response.data.message);
      }
      dispatch("hideLoader");
      return error.response.data;
    }
  },
  async resetpassword({ commit }, data) {
    let notification = {};
    try {
      let response = await API.resetpassword(data);
      let user_data = response.data;
      notification = {
        message: "Password update successfully!",
        type: "SUCCESS",
      };
      commit("PUSH_NOTIFICATION", notification);
      setTimeout(() => {
        commit("PUSH_NOTIFICATION", {});
        router.push("/login");
      }, 7000);
    } catch (error) {
      if (error && error.response && error.response.data) {
        // console.error(error);
        commit("SET_ERROR", error);
        notification = {
          message: error.response.data.message,
          type: "DANGER",
        };
        commit("PUSH_NOTIFICATION", notification);
        setTimeout(() => {
          commit("PUSH_NOTIFICATION", {});
        }, 7000);
        commit("SET_ERROR", error.response.data.detail);
      }
    }
  },
  async changepassword({ commit, dispatch }, data) {
    dispatch("showLoader");
    let notification = {};
  try {
      let response = await API.changepassword(data);
      let user_data = response.data;
    // console.log("user_data++++++++++=", response);
      // console.log("user_data", user_data);
      // commit('SET_NOTIFICATION')
      notification = {
        message: "Password link sent! Please check mail",
        type: "SUCCESS",
      };
      commit("PUSH_NOTIFICATION", notification);
      setTimeout(() => {
        commit("PUSH_NOTIFICATION", {});
      }, 7000);
    } catch (error) {
      if (error && error.response && error.response.data) {
        // console.error(error);
        commit("SET_ERROR", error);
        notification = {
          message: error.response.data.message,
          type: "DANGER",
        };
        commit("PUSH_NOTIFICATION", notification);
        setTimeout(() => {
          commit("PUSH_NOTIFICATION", {});
        }, 7000);
        commit("SET_ERROR", error.response.data.detail);
      }
    }
    dispatch("hideLoader");
  },
  async sortbuckets({ commit }, order) {
    let notification = {};
    try {
      commit("SET_SORT_ORDER_USER_BUCKETS", order);
    } catch (error) {
      if (error && error.response && error.response.data) {
        // console.error(error);
        commit("SET_ERROR", error);
        notification = {
          message: error.response.data.message,
          type: "DANGER",
        };
        commit("PUSH_NOTIFICATION", notification);
        setTimeout(() => {
          commit("PUSH_NOTIFICATION", {});
        }, 7000);
        commit("SET_ERROR", error.response.data.detail);
      }
    }
  },
  async loadIframe({ commit }, data) {
    try {
      let content = await API.iframe(data);
      // console.log("conect-=-=", content);
      //let test = '<html><body>test</body></html>'
      commit(
        "SET_IFRAME",
        "data:text/html," + encodeURIComponent(content.data)
      );
    } catch (error) {
      // console.log("Login ERROR.....", error);
      commit("SET_ERROR", error);
    }
  },
};
const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USER: (state, user) => {
    state.user = user;
  },
  SET_USER_ACCESS_DETAILS: (state, userAccessDetails) => {
    state.userAccessDetails = userAccessDetails;
  },
  SET_ERROR: (state, errors) => {
    state.errors = errors;
  },
  PUSH_NOTIFICATION: (state, notification) => {
    // console.log("notification++++", notification);
    state.notifications = [];
    state.notifications.push({
      ...notification,
      id: (Math.random().toString(36) + Date.now().toString(36)).substr(2),
    });
  },
  SET_USER_BUCKETS: (state, userAccessDetails) => {
    state.userBuckets = [] 
    for(let [ii,dd] of userAccessDetails.entries()){
      state.userBuckets.push({
        title: dd.objectname,
        image:
          dd.objectname.indexOf(" ") >= 0
            ? dd.objectname.split(" ")[0].toLowerCase()
            : dd.objectname.split("/")[0].toLowerCase(),
        path: dd.objectname.replace(/\s/gi, "_").replace(/\//gi, "_"),
        is_visible: dd.is_visible
      })
    }
  },
  SET_SORT_ORDER_USER_BUCKETS: (state, order) => {
    state.userBuckets = _.orderBy(state.userBuckets, "title", order);
  },
  SET_IFRAME: (state, content) => {
    state.iframeData = content;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
